import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustrationNoShortlist = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 209,
	height: 200,
	viewBox: "0 0 209 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
			fill: "#B47DF4"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_31_1819)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M145 58H81C77.6863 58 75 60.6863 75 64V139C75 142.314 77.6863 145 81 145H145C148.314 145 151 142.314 151 139V64C151 60.6863 148.314 58 145 58Z",
				fill: "#C8D5FF"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_d_31_1819)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M137 50H61C57.6863 50 55 52.6863 55 56V149C55 152.314 57.6863 155 61 155H137C140.314 155 143 152.314 143 149V56C143 52.6863 140.314 50 137 50Z",
				fill: "#C8D5FF"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_d_31_1819)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M128.003 42.999H51.003C47.6893 42.999 45.003 45.6853 45.003 48.999V156.999C45.003 160.313 47.6893 162.999 51.003 162.999H128.003C131.317 162.999 134.003 160.313 134.003 156.999V48.999C134.003 45.6853 131.317 42.999 128.003 42.999Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .102,
			d: "M118 133H61C59.8954 133 59 133.895 59 135V137C59 138.105 59.8954 139 61 139H118C119.105 139 120 138.105 120 137V135C120 133.895 119.105 133 118 133Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .102,
			d: "M107 142H73C71.8954 142 71 142.895 71 144V145C71 146.105 71.8954 147 73 147H107C108.105 147 109 146.105 109 145V144C109 142.895 108.105 142 107 142Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 56.001H70C65.0294 56.001 61 60.0304 61 65.001C61 69.9715 65.0294 74.001 70 74.001H108C112.971 74.001 117 69.9715 117 65.001C117 60.0304 112.971 56.001 108 56.001Z",
			fill: "#F6FBA9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108 101C108 90.5066 99.4934 82 89 82C78.5066 82 70 90.5066 70 101C70 111.493 78.5066 120 89 120C99.4934 120 108 111.493 108 101Z",
			fill: "#4B75FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.625 104.656H93.55C93.55 104.656 92.593 108.856 93.55 111.035C94.507 113.214 84.728 112.579 85.625 111.035C86.522 109.491 85.625 104.656 85.625 104.656Z",
			fill: "#D39F2A"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .186,
			d: "M89.796 96.306C93.875 96.448 93.916 98.104 93.916 100.326V102.998C93.916 105.216 91.109 107.014 89.795 107.014C88.481 107.014 85.675 105.216 85.675 102.998V100.326C85.675 98.104 85.718 96.163 89.796 96.306Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.909 108.549C86.181 108.649 88.101 110.09 90.028 110.063C91.175 109.89 92.2384 109.361 93.067 108.549C101.455 110.12 103.282 111.996 103.282 114.31V119.024C103.296 120.12 102.875 121.178 102.11 121.963C101.345 122.749 100.299 123.199 99.203 123.214H80.337C79.2406 123.199 78.195 122.749 77.4301 121.963C76.6652 121.178 76.2436 120.12 76.258 119.024C76.258 119.024 76.158 116.481 76.258 114.31C76.358 112.139 78.758 110.532 85.909 108.549Z",
			fill: "#EEF755"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.755 96.7456C83.6988 96.2131 83.2216 95.827 82.6891 95.8832C82.1566 95.9394 81.7705 96.4166 81.8267 96.9491L82.1829 100.324C82.2391 100.857 82.7163 101.243 83.2488 101.187C83.7813 101.13 84.1674 100.653 84.1112 100.121L83.755 96.7456Z",
			fill: "#D39F2A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.796 88.117C96.553 88.375 96.625 91.371 96.625 95.385V100.231C96.625 104.245 91.973 107.499 89.796 107.499C87.619 107.499 82.967 104.243 82.967 100.231V95.384C82.967 91.371 83.038 87.858 89.796 88.117Z",
			fill: "#D39F2A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.7655 96.9496C97.8217 96.4171 97.4356 95.9399 96.9031 95.8837C96.3706 95.8275 95.8934 96.2136 95.8372 96.7461L95.4811 100.121C95.4249 100.654 95.811 101.131 96.3435 101.187C96.876 101.243 97.3532 100.857 97.4094 100.325L97.7655 96.9496Z",
			fill: "#D39F2A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.796 107.497H89.79V88.116H89.796C92.914 88.235 94.804 88.943 95.745 90.342C96.625 91.651 96.625 93.465 96.625 95.384V100.229C96.5604 101.217 96.2968 102.181 95.85 103.064C95.4032 103.947 94.7824 104.731 94.025 105.368C93.3528 105.989 92.5975 106.513 91.781 106.926C91.1687 107.258 90.4913 107.453 89.796 107.497Z",
			fill: "#BE8D21"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.961 97.894V95.384C82.961 93.551 82.961 91.655 83.754 90.291C84.1727 89.5738 84.8148 89.0136 85.582 88.696C86.704 88.2578 87.9044 88.0559 89.108 88.103C89.327 88.103 89.557 88.103 89.789 88.116C92.907 88.235 94.797 88.942 95.737 90.342C96.617 91.651 96.617 93.465 96.617 95.384V96.613C96.068 96.566 94.807 96.433 92.526 96.076C90.9941 95.8015 89.5261 95.2461 88.196 94.438C87.5497 94.0673 86.9314 93.6498 86.346 93.189L85.968 93.929C85.968 93.923 85.684 93.29 85.392 93.29C85.3433 93.2944 85.2966 93.311 85.256 93.3383C85.2155 93.3655 85.1825 93.4026 85.16 93.446C85.0207 93.6934 84.9515 93.9741 84.96 94.258C84.9251 94.8843 84.7806 95.4996 84.533 96.076C84.4097 96.4705 84.2065 96.8355 83.9361 97.1481C83.6656 97.4607 83.3337 97.7142 82.961 97.893V97.894Z",
			fill: "#0D2976"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_d_31_1819)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M200 30C200 18.9543 191.046 10 180 10C168.954 10 160 18.9543 160 30C160 41.0457 168.954 50 180 50C191.046 50 200 41.0457 200 30Z",
				fill: "#FF7181"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M182.578 29.5L186.484 33.4453C186.992 33.9141 186.992 34.6953 186.484 35.1641L185.625 36.0234C185.156 36.5312 184.375 36.5312 183.906 36.0234L180 32.1172L176.055 36.0234C175.586 36.5312 174.805 36.5312 174.336 36.0234L173.477 35.1641C172.969 34.6953 172.969 33.9141 173.477 33.4453L177.383 29.5L173.477 25.5938C172.969 25.125 172.969 24.3438 173.477 23.875L174.336 23.0156C174.805 22.5078 175.586 22.5078 176.055 23.0156L180 26.9219L183.906 23.0156C184.375 22.5078 185.156 22.5078 185.625 23.0156L186.484 23.875C186.992 24.3438 186.992 25.125 186.484 25.5938L182.578 29.5Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_31_1819",
				x: 63,
				y: 52,
				width: 100,
				height: 111,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1819"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1819",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_31_1819",
				x: 43,
				y: 44,
				width: 112,
				height: 129,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 6 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 6 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1819"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1819",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_31_1819",
				x: 35.003,
				y: 42.999,
				width: 109,
				height: 140,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.102 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1819"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1819",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_d_31_1819",
				x: 154,
				y: 7,
				width: 52,
				height: 52,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_31_1819"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_31_1819",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgIllustrationNoShortlist;
